var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPremiumBadge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5192_245",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5192_245)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 21V19H11.5V15.9C10.6833 15.7167 9.95417 15.3708 9.3125 14.8625C8.67083 14.3542 8.2 13.7167 7.9 12.95C6.65 12.8 5.60417 12.2542 4.7625 11.3125C3.92083 10.3708 3.5 9.26667 3.5 8V7C3.5 6.45 3.69583 5.97917 4.0875 5.5875C4.47917 5.19583 4.95 5 5.5 5H7.5V3H17.5V5H19.5C20.05 5 20.5208 5.19583 20.9125 5.5875C21.3042 5.97917 21.5 6.45 21.5 7V8C21.5 9.26667 21.0792 10.3708 20.2375 11.3125C19.3958 12.2542 18.35 12.8 17.1 12.95C16.8 13.7167 16.3292 14.3542 15.6875 14.8625C15.0458 15.3708 14.3167 15.7167 13.5 15.9V19H17.5V21H7.5ZM7.5 10.8V7H5.5V8C5.5 8.63333 5.68333 9.20417 6.05 9.7125C6.41667 10.2208 6.9 10.5833 7.5 10.8ZM12.5 14C13.3333 14 14.0417 13.7083 14.625 13.125C15.2083 12.5417 15.5 11.8333 15.5 11V5H9.5V11C9.5 11.8333 9.79167 12.5417 10.375 13.125C10.9583 13.7083 11.6667 14 12.5 14ZM17.5 10.8C18.1 10.5833 18.5833 10.2208 18.95 9.7125C19.3167 9.20417 19.5 8.63333 19.5 8V7H17.5V10.8Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremiumBadge);
export default __webpack_public_path__ + "static/media/premium-badge.0e31ce3bc276493c392e2f5a75259c58.svg";
export { ForwardRef as ReactComponent };